/* Multi-Card packs go as one parcel.
 *
 * mb-flow.js marks each card line "Delivery Format: Letterbox" or "Parcel"
 * from the slices and extras of ONE card. A Multi-Card pack (2-10 cards to
 * one address) is posted as a single parcel whatever is inside, so on those
 * orders the line said Letterbox while the postage line said Multi-Card.
 *
 * This wraps fetch after mb-multibuy.js has (its wrapper sets the quantity)
 * and, when the flow is on Multi-Card (data-mb-card-quantity > 1), sets
 * Delivery Format to Parcel on the card going into /cart/add. Single cards
 * are left exactly as they were. Any error leaves the request untouched.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-mb-flow]');
  var prev = window.fetch;
  if (!root || typeof prev !== 'function') return;
  var KEY = 'Delivery Format';

  var multi = function () {
    return (parseInt(root.getAttribute('data-mb-card-quantity'), 10) || 1) > 1;
  };

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (multi() && init && init.body && String(url).indexOf('/cart/add') > -1) {
        if (typeof init.body === 'string') {
          var j = JSON.parse(init.body);
          if (j && Array.isArray(j.items)) {
            j.items.forEach(function (it) {
              var pr = it.properties;
              if (pr && pr._mb_group && pr[KEY]) pr[KEY] = 'Parcel';
            });
            init.body = JSON.stringify(j);
          }
        } else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
          if (init.body.get('properties[_mb_group]') && init.body.get('properties[' + KEY + ']')) {
            init.body.set('properties[' + KEY + ']', 'Parcel');
          }
        }
      }
    } catch (e) { /* leave the request exactly as it was */ }
    return prev.apply(this, arguments.length > 1 ? [input, init] : arguments);
  };
})();
